import React, { Component } from 'react'
import './App.css'
import {
  withFirebase,
  firebaseConnect,
  isLoaded,
  isEmpty,
  populate
} from 'react-redux-firebase'
import { userActions } from '../actions/user.actions'
import { entityActions } from '../actions/entity.actions'

import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import classNames from 'classnames'
import { styles } from './dockPadStyle'
import CustomSnackbar from '../components/CustomSnackbar'
import Snackbar from '@material-ui/core/Snackbar'
import { alertActions } from '../actions/alert.actions'
import {
  dockPadEntityMapToList,
  formatDockPadEntityToGanttTask
} from './DockPadFormTemplates'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Drawer from '@material-ui/core/Drawer'
import EditBoard from './EditBoardScreen'
import { homeActions } from '../actions/home.actions'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { getFirebase } from 'react-redux-firebase'

var _ = require('lodash')

class UpdateRequestPortalScreen extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const firebase = getFirebase()
    firebase
      .auth()
      .signInAnonymously()
      .catch(error => {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        // ...
        console.log('signInAnonymously error', error)
      })
      .then(response => {
        console.log('signInAnonymously response', response)
      })
  }
  handleSnackbarClose = (event, reason) => {
    this.props.dispatch(alertActions.clear())
  }

  taskRowClicked(row) {
    const { dispatch } = this.props
    const entityType = row.entityType

    dispatch(homeActions.openEditBoard(row.id, entityType))
  }

  renderEditBoard() {
    const { editBoardInfo, dispatch } = this.props
    return (
      <Drawer
        anchor='right'
        open={!!editBoardInfo}
        onClose={() => {
          dispatch(homeActions.closeEditBoard())
        }}>
        <EditBoard selectedProject={this.props.updateRequestProject} />
      </Drawer>
    )
  }

  renderTaskList() {
    const { tasks } = this.props
    if (!tasks) {
      return 'Loading...'
    }

    return (
      <List>
        {tasks.map(item => {
          return (
            <ListItem onClick={() => this.taskRowClicked(item)}>
              <ListItemText
                primary={item.name}
                secondary={`WBS Code ${item.code}`}
              />
              <ListItemSecondaryAction>
                <ChevronRightIcon />
              </ListItemSecondaryAction>
            </ListItem>
          )
        })}
      </List>
    )
  }

  handleSaveProgress() {
    const { dispatch, updateRequestId } = this.props

    dispatch(entityActions.saveUpdateRequestProgress(updateRequestId))
  }

  render() {
    const { classes, alert, tasks, updateRequest } = this.props
    let alertMessage = ''
    let alertType = 'success'
    if (!_.isEmpty(alert)) {
      alertMessage = alert.message
      if (alert.type === 'alert-success') {
        alertType = 'success'
      } else if (alert.type === 'alert-danger') {
        alertType = 'error'
      }
    }
    console.log(
      'invalid link check',
      updateRequest,
      !!updateRequest && updateRequest.status == 'done'
    )
    if (isEmpty(updateRequest)) {
      return (
        <div
          style={{ backgroundColor: '#FAFAFA' }}
          className={classNames(
            classes.flexGrowRoot,
            classes.centeredHorizontal,
            classes.standardTopPadding
          )}>
          <Typography variant='title'>Invalid Link</Typography>
        </div>
      )
    }

    if (!!updateRequest && updateRequest.status == 'done') {
      return (
        <div
          style={{ backgroundColor: '#FAFAFA' }}
          className={classNames(
            classes.flexGrowRoot,
            classes.centeredHorizontal,
            classes.standardTopPadding
          )}>
          <Typography variant='title'>Update Successful</Typography>
        </div>
      )
    }

    return (
      <div
        style={{ backgroundColor: '#FAFAFA' }}
        className={classNames(
          classes.flexGrowRoot,
          classes.centeredHorizontal,
          classes.standardTopPadding
        )}>
        <Snackbar
          open={!_.isEmpty(alert)}
          onClose={this.handleSnackbarClose}
          autoHideDuration={2000}>
          <CustomSnackbar
            onClose={this.handleSnackbarClose}
            variant={alertType}
            message={alertMessage}
          />
        </Snackbar>
        <div
          className={classNames(
            classes.flexRoot,
            classes.centeredVertical,
            classes.flexColumn
          )}>
          {this.renderEditBoard()}
          <Typography variant='title'>
            Please update these tasks according to your work completed
          </Typography>
          <Button
            className={classNames(classes.standardTopMargin)}
            variant='outlined'
            color='primary'
            onClick={this.handleSaveProgress.bind(this)}>
            Save Progress
          </Button>
          <Paper className={classNames(classes.standardTopMargin)}>
            {this.renderTaskList()}
          </Paper>
        </div>
      </div>
    )
  }
}
export default compose(
  withFirebase,
  withRouter,
  withStyles(styles, { withTheme: true }),
  firebaseConnect((props, state) => {
    const updateRequestId = props.match.params.id
    console.log('firebase auth 1', state.firebase.auth)

    return [
      { path: `/updateRequest/${updateRequestId}`, storeAs: 'UPDATE_REQUEST' }
    ]
  }),
  connect((state, props) => {
    const updateRequest = state.firebase.data.UPDATE_REQUEST

    const updateRequestId = props.match.params.id

    console.log('connect updateRequest', state.firebase.data)
    console.log('firebase auth 2', state.firebase.auth)

    return {
      updateRequestId: updateRequestId,
      alert: state.alert,
      updateRequest: updateRequest
    }
  }),
  firebaseConnect((props, state) => {
    const { updateRequest } = props
    console.log('firebaseConnect', updateRequest)
    console.log('firebase auth 3', state.firebase.auth)

    if (!isLoaded(updateRequest) || isEmpty(updateRequest)) {
      return {}
    }

    return [
      {
        path: `projects/${updateRequest.projectId}`,
        storeAs: 'UPDATE_REQUEST_PROJECT'
      }
    ]
  }),
  connect((state, props) => {
    const updateRequestProject = state.firebase.data.UPDATE_REQUEST_PROJECT
    const updateRequest = state.firebase.data.UPDATE_REQUEST

    console.log('updateRequestProject', state.firebase.data)
    console.log('firebase auth 4', state.firebase.auth)

    if (!isLoaded(updateRequestProject) || isEmpty(updateRequestProject)) {
      return {}
    }

    updateRequestProject['uid'] = updateRequest.projectId
    const taskIds = new Set(updateRequest.taskIds)
    const tasks = !!updateRequestProject.tasks ? updateRequestProject.tasks : {}
    const taskList = dockPadEntityMapToList(tasks)
    const formattedTasks = formatDockPadEntityToGanttTask(
      taskList,
      'Task',
      'tasks'
    )
    const filteredTasks = formattedTasks.filter(item => taskIds.has(item.id))

    return {
      updateRequestProject: updateRequestProject,
      tasks: filteredTasks,
      editBoardInfo: state.homeView.editBoardInfo
    }
  })
)(UpdateRequestPortalScreen)



// WEBPACK FOOTER //
// ./src/containers/UpdateRequestPortal.tsx